import React from 'react';
import MediaThumbnail from './MediaThumbnail/MediaThumbnail';
import CloudinaryThumb from './CloudinaryThumb/CloudinaryThumb';
import * as constants from '../../../constants';
import './Thumbnail.scss';

const Thumbnail = ({
  alt,
  deleted,
  dragHandle,
  dragHandleProps,
  handleClick,
  height,
  logo,
  mediaId,
  mediaUrl,
  mediaType,
  name,
  noBackground,
  overlayMediaName,
  pad,
  publicId,
  selectedMedia,
  tabIndex,
  thumbBtns,
  thumbClass,
  thumbSrc,
  view,
  width,
}) => {
  if (mediaType === constants.VIDEOS) {
    return (
      <MediaThumbnail
        alt={alt}
        classes={thumbClass}
        dragHandle={dragHandle}
        dragHandleProps={dragHandleProps}
        handleClick={handleClick}
        height={height}
        id={mediaId}
        key={mediaId}
        name={name}
        overlayMediaName={overlayMediaName}
        src={thumbSrc}
        tabIndex={tabIndex}
        thumbBtns={thumbBtns}
      />
    );
  }
  return (
    <CloudinaryThumb
      alt={alt}
      publicId={publicId}
      classes={thumbClass}
      deleted={deleted}
      dragHandle={dragHandle}
      dragHandleProps={dragHandleProps}
      handleClick={handleClick}
      height={height}
      id={mediaId}
      mediaUrl={mediaUrl || thumbSrc}
      key={mediaId}
      logo={logo}
      mediaType={mediaType}
      name={name}
      noBackground={noBackground}
      overlayMediaName={overlayMediaName}
      pad={pad}
      selectedMedia={selectedMedia}
      tabIndex={tabIndex}
      thumbBtns={thumbBtns}
      view={view}
      width={width}
    />
  );
};

export default Thumbnail;
